import React from 'react';
import MaterialTable from 'material-table';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Rating from '@material-ui/lab/Rating';
import { localizationTable, options } from 'constants/table';
import { ReportCompanyData } from 'services/dataService';
import RATINGSDetailJSON from 'constants/JSONConstants/ratings-detail-table-columns';

export default ({ open, onClose, idCompanyCourse, courseName }) => {
  const { t } = useTranslation(['tables']);

  const fields = RATINGSDetailJSON.map(({ title, field, selected }) => {
  if (field === 'rating') {
    return {
      title: t(title),
      field,
      hidden: !selected,
      sorting: false,
      cellStyle: {
        textAlign: 'center',
      },
      headerStyle: {
        textAlign: 'center',
      },
      render: (rowData) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            width: '100%',
          }}
        >
          <Rating
            value={Number(rowData.rating)}
            precision={1}
            readOnly
            size="small"
          />
          <span
            style={{
              fontWeight: 600,
              minWidth: 18,
            }}
          >
            {Number(rowData.rating).toFixed(0)}
          </span>
        </div>
      ),
    };
  }

  return {
    title: t(title),
    field,
    hidden: !selected,
    sorting: false,
  };
});

 return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Avaliações — {courseName}</DialogTitle>
      <DialogContent>
        {open && (
          <MaterialTable
            title=""
            columns={fields}
            data={async (query) => {
              try {
                const response = await ReportCompanyData.getRatingsDetail({
                  page: query.page + 1,
                  limit: query.pageSize,
                  idCompanyCourse,
                  filter: query.search,                   
                });
                
                const { report, currentPage, totalCount } = response.data;

                return {
                  data: report,
                  page: currentPage - 1,
                  totalCount,
                };
              } catch (error) {
                return { data: [] };
              }

               

            }}
            localization={localizationTable(t)}
            options={{
              ...options,
              exportButton: false,
              search: true,
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};